import { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import client from "../lib/api";
import { useAuth } from "../lib/AuthContext";

export default function AuthCallback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { setSession } = useAuth();

  useEffect(() => {
    const code = params.get("code");
    if (!code) {
      navigate("/");
      return;
    }
    client
      .post("/auth/discord/callback", { code })
      .then((r) => {
        setSession(r.data);
        navigate("/account");
      })
      .catch(() => navigate("/"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <main className="pt-40 min-h-screen text-center font-mono text-zinc-400">
      Authenticating...
    </main>
  );
}
